<template>
  <component
    :is="wysiwygTagImports[el.tag] ?? defaultHandler"
    v-for="(el, index) in items"
    :key="index"
    :el="el"
  />
</template>
<script setup lang="ts">
import transformHTMLToJson from '../../../htmlToJsonTransformer/transformHTMLToJson';
import { wysiwygTagImports } from '../../tagHandlers/minilu/dynamicImportMap';
import defaultHandler from '../../tagHandlers/minilu/default.vue';
import type { HTMLElementSimplified } from '@/components/components/cms/wysiwyg/types';

const props = defineProps({
  json: {
    type: Array as PropType<HTMLElementSimplified[]>,
    required: false,
    default: null,
  },
  html: {
    type: String,
    default: '',
    required: false,
  },
  filterElements: {
    type: Function as PropType<
      (content: HTMLElementSimplified[]) => HTMLElementSimplified[]
    > | null,
    required: false,
    default: null,
  },
});

const resolvedHtml = await transformHTMLToJson(
  props.html,
  props.filterElements,
);
const items = props.json || resolvedHtml;
</script>
